module.exports = __webpack_public_path__ + "img/efficiency4.b1fa4ef6.png";